import React, { useState, useCallback, useEffect } from "react";
import { GoogleMap, LoadScript, DirectionsService, DirectionsRenderer, InfoWindow, Marker, MarkerProps } from "@react-google-maps/api";
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import PersonPinCircleIcon from '@material-ui/icons/PersonPinCircle';
import { Filter } from "@material-ui/icons";
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Checkbox from '@material-ui/core/Checkbox';

const containerStyle = {
  width: "1200px",
  height: "500px",
  alignItems: "center",
};

const useStyles = makeStyles({
  root: {
    width: 1200,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  rootx: {
    width: '100%',
    maxHeight: 670,
     overflow: 'auto'
    //maxWidth: '36ch',
    // backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  }
});

const Accordion = withStyles({
  root: {
    width: "1200px",
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

const MapComponent = ({ destinationX, originX, markers, infoWindow, time }) => {
  const classes = useStyles();
  const [map, setMap] = useState(null);
  const origin = originX;

  const [destination, setDestination] = useState(destinationX);

  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();
    map.fitBounds(bounds);
    setMap(map);
  }, []);


  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);
  const [checked, setChecked] = React.useState(true);
  const [timeFrame, setTimeFrame] = useState(time);

  const [selectedIndex, setSelectedIndex] = React.useState(0);


  const [expanded, setExpanded] = React.useState();
  const [filteredMakers, setFilteredMakers] = React.useState(markers);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [directions, setDirection] = useState();

  const [currentMaker, setCurrentMaker] = useState({
    markerID: 0,
    latitude: 0,
    longitude: 0,
    readTime: "",
    weight: "",
    numberOfUnits: "",
    customerID: "",
    narration: ""

  });
  const divStyle = {
    width: "120px",
    height: "40px",
    background: `white`,
    fontSize: 7,
  };

  useEffect(() => {
    setCurrentMaker({
      markerID: 0,
      latitude: 0,
      longitude: 0,
      readTime: "",
      weight: "",
      numberOfUnits: "",
      customerID: "",
      narration: ""
    });
    setExpanded("");
  }, [originX]);

  const onLoadx = (infoWindow) => { };

  const waypoints = markers.map((m) => ({
    location: { lat: m.latitude, lng: m.longitude },
    stopover: true,
  }));

  const destinationService = {
    destination: destination,
    origin: origin,
    travelMode: "DRIVING",
    waypoints: waypoints
  };

  const directionRender = {
    directions: directions,
  };

  const [defaultset, setDefaultset] = useState({
    lat: 6.927079,
    lng: 79.861244,
  })


  function calculateTotal() {
    var total = 0;
    infoWindow.map((store) => {
      total = total + store.weight;
    });
    return total;
  }

  function findStart() {
    var total = 0;
    infoWindow.map((store) => {
      total = total + store.weight;
    });
    return total;
  }



  function makers() {
    if (selectedIndex == 0) {
      return filteredMakers.map((mark, index) => <Marker label={(index + 1).toString()} onClick={(e) => onclickMarker(e, mark, index)} key={index} position={{ lat: mark.latitude, lng: mark.longitude }} />)
    } else {
      return filteredMakers.map((mark, index) => <Marker label="" onClick={(e) => onclickMarker(e, mark, index)} key={index} position={{ lat: mark.latitude, lng: mark.longitude }} />)

    }

  }



  const handleToggle = (e) => {
    setSelectedIndex(0);

    if (e.target.value = true) {
      setFilteredMakers(markers);
      setChecked(true);
    } else {
      setFilteredMakers([]);
      setChecked(false);
    }

  };




  function makeMakersList() {
    return markers.map((mark, index) =>

      <>
        <ListItem alignItems="flex-start" button selected={selectedIndex === index + 1}
          onClick={(event) => handleListItemClick(event, mark, index)}>

          <ListItemIcon>
            <PersonPinCircleIcon />
          </ListItemIcon>
          <ListItemText
            primary={"Point :" + (index + 1).toString()}
          />

        </ListItem>
        <Divider component="li" /></>
    )

  }


  function onclickMarker(e, mark, index) {
    setExpanded('panel3')
    var timeArr = mark.readTime.split("T");
    setCurrentMaker({
      markerID: index + 1,
      latitude: mark.latitude,
      longitude: mark.longitude,
      readTime: timeArr[1],
      weight: mark.weight,
      numberOfUnits: mark.numberOfUnits,
      customerID: mark.customerID,
      registrationNumber: mark.registrationNumber,
      nameToBePrinted: mark.nameToBePrinted,
      cardReadCategory: mark.cardReadCategory,
      narration: mark.narration
    });
  }

  const handleListItemClick = (event, mark, i) => {
    setFilteredMakers([]);
    setDestination([]);

    setChecked(false);
    var finalResult = markers.filter((item, index) => index === i)
    setFilteredMakers(finalResult);
    setDestination({
      lat: mark.latitude,
      lng: mark.longitude
    });

    setSelectedIndex(i + 1);
    setExpanded('panel3');
    var timeArr = mark.readTime.split("T");
    setCurrentMaker({
      markerID: i + 1,
      latitude: mark.latitude,
      longitude: mark.longitude,
      readTime: timeArr[1],
      weight: mark.weight,
      numberOfUnits: mark.numberOfUnits,
      customerID: mark.customerID,
      registrationNumber: mark.registrationNumber,
      nameToBePrinted: mark.nameToBePrinted,
      cardReadCategory: mark.cardReadCategory,
      narration: mark.narration
    });


  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={3}>

          <List className={classes.rootx} >

            <Divider component="li" />

            <ListItem alignItems="flex-start" button  >

              <ListItemText
                primary={"Show All Points"}
              />
              <ListItemSecondaryAction>
                <Checkbox
                  edge="end"
                  onChange={(e) => handleToggle(e)}
                  checked={checked}
                // inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <Divider component="li" />


            {makeMakersList()}

          </List>

        </Grid>

        <Grid item xs={9}>

          <Card className={classes.root}>
            <CardContent>
              <Grid container className={classes.root} spacing={2}>
                <Grid item xs={4}>
                  <Typography variant="body2" component="h5"> Total : {calculateTotal()} Kg</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="h5">Start Time :{time.start}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="h5">End Time      :{time.end}</Typography>
                </Grid>

              </Grid>
            </CardContent>
          </Card>
          <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
            {/* <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Grid container className={classes.root} spacing={2}>

              <Grid item xs={8}>
                {currentMaker.markerID==0?<Typography variant="h6"  gutterBottom>Click on a WayPoint</Typography>:<Typography variant="h6"  gutterBottom>WayPoint : {currentMaker.markerID} / {markers.length}</Typography>}
              </Grid>

           </Grid>
        </AccordionSummary> */}
            <AccordionDetails>

              <Typography>
                <Grid container className={classes.root} spacing={2}>
                  <Grid item xs={4}>
                    <Typography variant="body2" component="h2">
                      Point :{currentMaker.markerID}
                    </Typography>
                    {currentMaker.cardReadCategory == 2 ? <Typography variant="body2" component="h2"><Chip label="New" /> </Typography>
                      :
                      <Typography variant="body2" component="h2">
                        Registration Number : {currentMaker.registrationNumber}
                      </Typography>
                    }

                    <Typography variant="body2" component="h2">
                      Name : {currentMaker.nameToBePrinted}
                    </Typography>
                    <Typography variant="body2" component="h2">
                      Time : {currentMaker.readTime}
                    </Typography>

                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2" component="h2">
                      Net Weight : {currentMaker.weight}Kg
                    </Typography>
                    <Typography variant="body2" component="h2">
                      Bag Count : {currentMaker.numberOfUnits}
                    </Typography>
                    <Typography variant="body2" component="h2">
                      Narration : {currentMaker.narration}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2" component="h2">
                      Logtitude : {currentMaker.longitude}
                    </Typography>
                    <Typography variant="body2" component="h2">
                      Latitiude : {currentMaker.latitude}
                    </Typography>
                  </Grid>
                </Grid>
              </Typography>
            </AccordionDetails>
          </Accordion>







          <LoadScript googleMapsApiKey="AIzaSyB-WLxFWGclALjB5I_YV2KAH5tf10Y8EIY">
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={destination}
              zoom={14}
              onLoad={onLoadx}
              onUnmount={onUnmount}
            >
              {/* <DirectionsService
          options={destinationService}
          callback={directionsCallback}
        /> */}

              {/* <DirectionsRenderer
          options={directionRender}
        /> */}
              {/* {displayMarkers()} */}
              {makers()}

              {/* {markers.map((mark, index) => <Marker key={index} position={{lat: mark.latitude, lng:mark.longitude}} />)} */}
            </GoogleMap>
          </LoadScript>
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(MapComponent);
